export const ProductosActionTypes = {
    API_RESPONSE_SUCCESS: '@@productos/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@productos/API_RESPONSE_ERROR',

    GET_PRODUCTO: '@@productos/GET_PRODUCTO',
    LIST_PRODUCTOS: '@@productos/LIST_PRODUCTOS',

    SYNC_PRODUCTOS:'@@productos/SYNC_PRODUCTOS',

    RESET: '@@productos/RESET',
};
